import { combineReducers } from 'redux'
import meta from './meta'
import didYouKnow from './didYouKnow'
import articles from './articles'
import logoutUrls from './logoutUrls'

export default combineReducers({
  meta,
  didYouKnow,
  articles,
  logoutUrls
})
